import { render } from "./dataset.vue?vue&type=template&id=4bd7deaa&ts=true"
import script from "./dataset.vue?vue&type=script&lang=ts"
export * from "./dataset.vue?vue&type=script&lang=ts"

import "./dataset.vue?vue&type=style&index=0&id=4bd7deaa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__